import { createSlice } from "@reduxjs/toolkit"

const initialStateObservacion = {
  idObservacion: '',
  idDenuncia: '',
  idJuicio: '',
  documentos: [],
  files: []
}

export const datosObservacionSlice = createSlice({
  name: "observacionJuicio",
  initialState: initialStateObservacion,
  reducers: {
    resetObservacion: (state) => {
      state.pagoSinFactura = { ...initialStateObservacion.observacionJuicio }
    },
    setIdDenuncia: (state, action) => {
      state.idDenuncia = action.payload
    },
    setIdJuicio: (state, action) => {
      state.idJuicio = action.payload
    },
    setIdObservacion: (state, action) => {
      state.idObservacion = action.payload
    },
    setDocumentos: (state, action) => {
      state.documentos = action.payload
    },
    addDocumentos: (state, action) => {
      state.documentos = [...state.documentos, action.payload]
    },
    addFiles: (state, action) => {
      state.files = [...state.files, action.payload]
    },
    resetDocumentos: (state) => {
      state.documentos = initialStateObservacion.documentos
      state.files = initialStateObservacion.files
    },
    resetIdObservacion: (state) => {
      state.idObservacion = initialStateObservacion.idObservacion
    },
    resetIdJuicio: (state) => {
      state.idJuicio = initialStateObservacion.idJuicio
    }
  }
})

export const { addDocumentos, resetDocumentos, setDocumentos, addFiles, setIdObservacion, resetIdObservacion, setIdDenuncia, setIdJuicio, resetObservacion, resetIdJuicio } = datosObservacionSlice.actions
export default datosObservacionSlice.reducer
